// extracted by mini-css-extract-plugin
export default {"wrapper":"Q9Lhqq","glitch":"IgbEpz","text":"C6EyP4"};